/* eslint-disable react/prop-types */
import { makeStyles, Popover } from "@material-ui/core";
import React, { useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: "border-box",
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  typography: {
    padding: theme.spacing(2),
  },
  popoverButton: {
    width: "auto",
    boxSizing: "border-box",
    border: "none",
    padding: "10px 10px",
    borderRadius: "3px",
    // background: "#EF6A5E",
    // background: "#fff",
    background: "#f4f4f4",
    color: "#4e4e4e",
    // color: "#EF6A5E",
    cursor: "pointer",
    display: "flex",
    gap: "5px",
    justifyContent: "space-between",
    fontWeight: "normal",
  },
}));

export default function PromotionsLegendDropdownButton({
  selectedScenarioLabel,
  children,
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setPopoverOpen(!popoverOpen);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setPopoverOpen(!popoverOpen);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div className={classes.root}>
      <div style={{ color: "#4E4E4E", fontWeight: "500" }}>Explore By:</div>{" "}
      <button
        className={classes.popoverButton}
        type="button"
        onClick={handleClick}
      >
        <div>{`${selectedScenarioLabel}`}</div>
        <div style={{ display: "flex", alignItems: "center" }}>
          {popoverOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
        </div>
      </button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {children}
      </Popover>
    </div>
  );
}
